import type { Locale } from "#i18n";

import { availableLocales } from "~/i18n/i18nConfig";

type NavigatorLanguage = string | `${string}-${string}`; // e.g. "en" or "en-US"

export default function findMatchingLocaleCode(
  navigatorLanguage: NavigatorLanguage,
): Locale {
  const localeWithExactMatch = availableLocales.find(
    (locale) => locale.language === navigatorLanguage,
  );

  if (localeWithExactMatch) {
    return localeWithExactMatch.code;
  }

  const navigatorBaseLanguage = navigatorLanguage.split("-")[0];
  const localeWithMatchingBase = availableLocales.find(
    (locale) => locale.language.split("-")[0] === navigatorBaseLanguage,
  );

  if (localeWithMatchingBase) {
    return localeWithMatchingBase.code;
  }

  return "en";
}
